import { render, staticRenderFns } from "./TimeOff.vue?vue&type=template&id=5940afd1&scoped=true&"
import script from "./TimeOff.vue?vue&type=script&lang=js&"
export * from "./TimeOff.vue?vue&type=script&lang=js&"
import style0 from "./TimeOff.vue?vue&type=style&index=0&id=5940afd1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5940afd1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
